import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resetPassword } from '../../lib/firebase/auth';
import { colors } from '../../styles/colors';

export default function ForgotPasswordPage() {
  const { t, i18n } = useTranslation();
  const isKo = i18n.language === 'ko';
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await resetPassword(email);
      setSent(true);
    } catch (err: any) {
      const code = err.code ?? '';
      if (code === 'auth/user-not-found' || code === 'auth/invalid-email') {
        setError(isKo ? '등록되지 않은 이메일입니다.' : 'Email not found.');
      } else if (code === 'auth/too-many-requests') {
        setError(isKo ? '요청이 너무 많습니다. 잠시 후 다시 시도해주세요.' : 'Too many requests. Please try again later.');
      } else {
        setError(isKo ? '비밀번호 재설정 메일 발송에 실패했습니다.' : 'Failed to send password reset email.');
      }
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6"
      style={{ backgroundColor: colors.background }}>
      <h1 className="mb-6 text-xl font-bold" style={{ color: colors.text }}>
        {t('auth.forgotPassword')}
      </h1>

      <div className="w-full max-w-[360px] rounded-xl p-5"
        style={{ backgroundColor: colors.surface, border: `1px solid ${colors.border}` }}>
        {sent ? (
          <div className="text-center">
            <p className="mb-4 text-sm" style={{ color: colors.primary }}>{t('auth.resetPasswordSent')}</p>
            <Link to="/login" className="text-sm font-semibold" style={{ color: colors.primary }}>
              {t('auth.login')}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-3">
            <input type="email" placeholder={t('auth.email')} value={email}
              onChange={(e) => setEmail(e.target.value)} required
              className="w-full rounded-lg border bg-transparent px-3 py-2.5 text-sm outline-none"
              style={{ borderColor: colors.border, color: colors.text }} />
            {error && <p className="text-center text-xs" style={{ color: colors.error }}>{error}</p>}
            <button type="submit"
              className="w-full rounded-lg py-2.5 text-sm font-bold text-white"
              style={{ backgroundColor: colors.primary }}>
              {t('common.send')}
            </button>
          </form>
        )}
      </div>

      <Link to="/login" className="mt-4 text-xs" style={{ color: colors.primary }}>
        ← {t('common.back')}
      </Link>
    </div>
  );
}
